module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "column has-text-centered",
    staticStyle: {
      "color": "red",
      "word-wrap": "break-word"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.error) + "\n                "), _c('br')]), _vm._v(" "), _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Enter your email address to reset your password.")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Email",
      "name": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Email')),
      expression: "errors.has('Email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Email')))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "has-text-right"
  }, [_c('router-link', {
    attrs: {
      "to": '/Login'
    }
  }, [_vm._v("Back to Login")])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableButton
    }
  }, [_vm._v("Reset Password")])])])])])])]), _vm._v(" "), _c('alertModal', {
    attrs: {
      "visible": _vm.showModal,
      "title": 'Message',
      "message": _vm.message,
      "okText": 'OK',
      "ok": _vm.closeModalBasic
    },
    on: {
      "close": _vm.closeModalBasic
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "image",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100px",
      "width": "auto"
    },
    attrs: {
      "src": require("assets/images/vti.png"),
      "alt": "Image1"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63b534f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/login/ForgotPassword.vue
// module id = 369
// module chunks = 66